import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import axios from "axios";
import Loader from "../../components/Loader";
import TopBar from "../../components/TopBar";
import Header from "../../components/headerfooter/Header";
import Footer from "../../components/headerfooter/Footer";
import CallToAction from "../../components/home/CallToAction";
import MobileFooter from "../../components/MobileFooter";
import { REACT_APP_API_PORT } from "../../Api";
import { getDecryptedData } from "../../config/crypto";
const UserCourseCertification = () => {
    const navigate = useNavigate()
    const {id} = useParams()
    const [data, setData] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    const getData = async () => {
        try {
            setisLoading(true);
          const token = getDecryptedData("token");
          const res = await axios.get(`${REACT_APP_API_PORT}user/course/order/user-course-details-by-id/${id}`, {
            headers: {
              "Content-Type": "application/json",
              "x-access-token": token,
            },
          });
          setisLoading(false);
          if (res.data.status) {
            setData(res.data.data);
          }
        } catch (err) {
            setisLoading(false);
          console.log(err);
        }
      };
    
    
    
    
      useEffect(() => {
        getData();
      }, []);
    
    return (
        <>
            <Loader isLoading={isLoading} />
            <TopBar />
            <Header />
            <div className="relative bg-background-back1 py-12 ">
                <div className="max-w-6xl text-white mx-auto ">

                    <div className="w-full">
                        <div className="flex items-center justify-center gap-1 lg:gap-4">
                            <div className="w-20 lg:w-24 h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent relative">
                                <div className="absolute inset-0 blur-[2px] bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>
                                <div className="absolute inset-0 blur-[4px] bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
                            </div>
                            <span className="w-max text-sm sm:text-base lg:text-3xl  text-[#959efe] font-light tracking-wider text-center">
                                Congratulations on completing the {data?.course_name} Course
                            </span>
                            <div className="w-20 lg:w-24 h-[1px] bg-gradient-to-r from-transparent via-blue-500 to-transparent relative">
                                <div className="absolute inset-0 blur-[2px] bg-gradient-to-r from-transparent via-blue-500 to-transparent"></div>
                                <div className="absolute inset-0 blur-[4px] bg-gradient-to-r from-transparent via-blue-400/50 to-transparent"></div>
                            </div>
                        </div>
                    </div>
                    <div className="w-full flex justify-center my-5">
                        <p className="text-center max-w-[610px]">Showcase your mastery of AI tools today by getting your AI Tools at Work Certification (Certification included free if you're a student of The Next Future AI ).</p>
                    </div>

                    <div className="p-4 flex justify-center my-8">
                        <button
                            type="button"
                            className=" md:w-auto px-6 py-3 border-2 border-customBlue text-white rounded font-semibold hover:bg-background-primary focus:ring-2 focus:ring-blue-500 disabled:bg-blue-400 transition duration-200"
                        >
                            GET CERTIFIED
                        </button>
                    </div>

                    <div className="flex flex-col md:flex-row items-center bg-gray1-100 border border-gray-100 p-6 rounded-md shadow-lg max-w-4xl mx-auto">
                        {/* Left Part - Bullet Points */}
                        <div className="w-full md:w-1/2 p-4">
                            <h2 className="text-xl font-semibold mb-3 text-white">Key Features</h2>
                            <ul className="list-disc list-outside pl-5 space-y-2 text-white">
                                <li>Industry-recognized certification that demonstrates your skills with AI tools</li>
                                <li>An online certificate to share and showcase your AI tools expertise</li>
                                <li>1-month membership to The Rundown AI University to advance your AI skills with hands-on learning</li>
                            </ul>
                        </div>

                        {/* Right Part - Image */}
                        <div className="w-full md:w-1/2 p-4 flex justify-center">
                            <img
                                src="/images/home_certificate.jpeg"
                                alt="Feature Illustration"
                                className="w-full max-w-xs rounded-lg shadow-md"
                            />
                        </div>
                    </div>

                    <div className="max-w-4xl mx-auto border border-gray-100 text-white p-6 rounded-md shadow-lg my-8">
                        <h2 className="text-xl font-semibold mb-4 text-white">Here's what you need to know:</h2>
                        <ul className="list-disc list-outside pl-5 space-y-2 text-white">
                            <li>The Certificate Exam is based on The Rundown's AI Tools at Work Course. We strongly recommend reviewing all course materials before attempting the exam (unless you’re already an AI expert!)</li>
                            <li>The test is a based on multiple-choice questions.</li>
                            <li>You need to score at least 75% to pass.</li>
                            <li>If you don't pass, you can retake the exam unlimited times. Don't forget to review the course materials before trying again!</li>
                            <li>After passing your certification exam, you'll receive an email containing your certificate of achievement.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <CallToAction />
            <Footer />
            <MobileFooter />
        </>
    );
};

export default UserCourseCertification;
